import React, { createContext, useState, useContext, useEffect } from 'react';
import axiosInstance from '../config/axios';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Cargar el estado inicial de autenticación
  useEffect(() => {
    const initAuth = () => {
      try {
        const storedUser = localStorage.getItem('usuario');
        const storedToken = localStorage.getItem('token');
        
        if (storedUser && storedToken) {
          console.log('🔄 [AuthContext] Restaurando sesión del usuario');
          setUser(JSON.parse(storedUser));
        } else {
          console.log('ℹ️ [AuthContext] No hay sesión guardada');
          setUser(null);
        }
      } catch (error) {
        console.error('❌ [AuthContext] Error al restaurar la sesión:', error);
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    initAuth();
  }, []);

  const login = async (userData) => {
    console.log('🔐 [AuthContext] Iniciando sesión del usuario');
    setUser(userData);
    localStorage.setItem('usuario', JSON.stringify(userData));
  };

  const logout = () => {
    console.log('🚪 [AuthContext] Cerrando sesión del usuario');
    setUser(null);
    localStorage.removeItem('usuario');
    localStorage.removeItem('token');
  };

  const updateUser = (userData) => {
    console.log('📝 [AuthContext] Actualizando datos del usuario');
    setUser(userData);
    localStorage.setItem('usuario', JSON.stringify(userData));
  };

  const isAuthenticated = () => {
    const hasUser = !!user;
    const hasToken = !!localStorage.getItem('token');
    console.log('🔍 [AuthContext] Verificando autenticación:', { hasUser, hasToken });
    return hasUser && hasToken;
  };

  const isAdmin = () => {
    return user?.rol === 'admin';
  };

  const isMedico = () => {
    return user?.rol === 'medico';
  };

  return (
    <AuthContext.Provider 
      value={{ 
        user, 
        login, 
        logout, 
        updateUser, 
        isAuthenticated, 
        isAdmin,
        isMedico,
        loading 
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth debe ser usado dentro de un AuthProvider');
  }
  return context;
};

export default AuthContext; 